import { createClient } from '@supabase/supabase-js';

// Supabase configuration - Production
const supabaseUrl = 'https://ndqjndvilkhfiinpmtoz.supabase.co';
// Admin panel service_role key kullanmalı (RLS bypass)
const supabaseServiceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kcWpuZHZpbGtoZmlpbnBtdG96Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0ODYxNzY2NCwiZXhwIjoyMDY0MTkzNjY0fQ.CXpNLDNZC4ER-qKczyx7cj41x0GoR-_nOo8gglPmLCA';

// Create Supabase client with service_role (admin panel)
export const supabase = createClient(supabaseUrl, supabaseServiceKey);

export default supabase; 